import React from 'react';
import {Radio} from 'antd';
import {BASIC_ELEMENT_SCHEMA} from "../layout/Group";
import {FieldControlProps} from "../metadata/fieldControlProps";

export const YesNoToggle = ({ value, onChange, ...props }: FieldControlProps<boolean>) => {

    const coercedValue: string = (undefined  !== value ? value.toString() :  null);

    const handleToggle = e => onChange(e.target.value === 'Yes');


    return <Radio.Group
        value={coercedValue}
        onChange={handleToggle}
        buttonStyle="solid"
        {...props}
    >
        <Radio.Button className="secondary-button" style={{ height: '31px', width: '108px', textAlign: 'center' }} value="Yes">Yes</Radio.Button>
        <Radio.Button className="secondary-button" style={{ height: '31px', width: '108px', textAlign: 'center' }} value="No">No</Radio.Button>
    </Radio.Group>
        ;
};

YesNoToggle.schema = BASIC_ELEMENT_SCHEMA;